import React, { useEffect } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"
import { post } from "./utils/apiClient"
import Cookies from "js-cookie"
import toast from "react-hot-toast"

export default function OauthCallback() {
  const [params] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const authCode = params.get("authCode")

    if (!authCode) {
      navigate("/", { replace: true })
      return
    }

    async function mintToken() {
      try {
        const data = await post("/oauth/mint-token", {
          authCode: authCode?.trim(),
        })

        if (data?.emailAddress) {
          Cookies.set("user", JSON.stringify(data), { expires: 8 })
          window.location.href = "/"
        } else {
          toast.error("Mint token failed", {
            duration: 5000,
          })
          navigate("/", { replace: true })
        }
      } catch (err) {
        toast.error("Mint token failed", {
          duration: 5000,
        })
        navigate("/", { replace: true })
      }
    }

    mintToken()
  }, [params, navigate])

  return (
    <div className="loading-container">
      <div className="loading-message">Loading...</div>
    </div>
  )
}
